module.exports = __webpack_public_path__ + "img/59.a63dc57e.png";